export type ApiResponse<T> = {
  message: string;
  data: T;
};

export type ErrorResponse<T> = {
  message: string;
  errorCode: string;
  errors: T | null;
};

export const ERROR_CODE = {
  tooManyRequests: 'TOO_MANY_REQUESTS',
  serverError: 'INTERNAL_SERVER_ERROR',
  smsFailedWithRetry: 'SMS_SEND_FAILED_WITH_RETRY',
} as const;
